import { mapGetters, mapState, mapMutations } from 'vuex';

export default {
  ...mapMutations('form', {setCsrf: 'setCsrf'}),
  methods: {
    async populateCsrf() {
      let script = `${this.domain}/api/forms/v1/c/${this.sig}.js?v=` + ((Date.now() % 1000) / 1000);
      var self = this;
      await this.$loadScript(script)
        .then(() => {
          self.setCsrf(_csrf());
          self.$unloadScript(script);
        })
        .catch(() => {
          this.$router.push({
            name: 'error',
            params: {
                height: this.height,
                title: 'Unable to load form',
                message: 'Please contact support if this issue persists.'
            }
          });
        });
    }
  },
  computed: {
    ...mapState('form', ['csrf']),
    ...mapGetters({
        sig: 'sig'
    }),
    ...mapGetters('form', [
        'csrf',
        'domain'
    ])
  }
};
